module.exports = __webpack_public_path__ + "assets/img/paperwalletemptyE.3fd05f3074132b75c8cfcca9a44f4044.svg";